import '../music.css';
import {Menu , Row, Col} from 'antd';
import { ApartmentOutlined,EyeOutlined, HomeOutlined,FileTextOutlined, TeamOutlined, UserOutlined, LogoutOutlined,} from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'
import {NavLink} from "react-router-dom";

import {logout,centerStyle} from './utils';

/** *
* *Menu used in all Admin Views, the only variable is the reports menu, that receives as a param
*/
class AdminMenu extends Component {
  render() {  
    const { SubMenu } = Menu;

    return (
        <div>
          <Row>
            <Col><NavLink to="/musicologia"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
          <Row>
            <Col span={19}>
              <Menu  defaultSelectedKeys={[this.props.defaultSelectedKey]} style={centerStyle} mode="horizontal">
                <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin"> Inicio</NavLink>
                </Menu.Item>
                <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin_plays_list"> Obras</NavLink>
                </Menu.Item>
                <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/musicologia/admin_conc_list'> Concursantes  </NavLink>
                </Menu.Item>
                {this.props.reportMenu}
         
          <Menu.Item key="jury" icon={<TeamOutlined  style={{ fontSize: '26px'}} />}>
              <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/musicologia/admin_jurado'> Jurado  </NavLink>
            </Menu.Item>
            <Menu.Item key="jury_process" icon={<ApartmentOutlined  style={{ fontSize: '26px'}} />}>
            <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/jury_process"> Proceso de Jurado</NavLink>
          </Menu.Item>
              </Menu>
            </Col>
            <Col span={5}>
              <Menu mode="horizontal" style={{float:'right'}}>
          <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
          <a onClick={logout}style={{fontSize:'20px', fontWeight:'bold', font:'black'}}> Cerrar sesión </a>
          </Menu.Item>
          
          </Menu>
            
            </Col>
          </Row>
          </div>
    );
  }
}
export default AdminMenu;


